import api from "@/api";
import SeesawQuestionSelector from "@/components/editor/SeesawQuestionSelector";
import SeesawImage from "@/components/subject/Seesaw/SeesawImage";
export default {
  name: "SeesawQuestionEditor",
  components: {
    SeesawQuestionSelector,
    SeesawImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      questions: [],
      typeMap: {},
      drawer: false,
      updateIndex: 0
    };
  },
  methods: {
    toAdd(idx) {
      this.updateIndex = idx;
      this.drawer = true;
    },
    onSelected(qid) {
      api.updateTplQuestionId({
        tplId: this.data.id,
        updateIndex: this.updateIndex,
        questionId: qid
      }).then(() => {
        this.drawer = false;
        this.fetchQuestions();
      });
    },
    fetchQuestions() {
      api.previewTplQuestion(this.data.id).then(ret => {
        this.questions = ret;
      });
    },
    init() {
      this.fetchQuestions();
    }
  },
  mounted() {
    this.init();
  }
};